import React, { useContext, useState } from "react";
import styled from "styled-components";
import { DataContext } from "../contexts/DataContext";
import { MdCancel, MdChevronLeft } from "react-icons/md";
import DataEntry from "./DataEntry";
import CountDataEntry from "./CountDataEntry";

const Main = styled.div`
  width: 100%;
  padding-top: 1em;
  height: 100vh;
`;

const Row = styled.div`
  padding: 0.5em;
  border-bottom: 1px solid #353748;
  width: 100%;
  display: flex;
  align-items: center;
  :hover {
    background-color: #6d2d3e;
  }
`;

const WeightInput = styled.input`
  background-color: #16181f;
  border: none;
  padding: 0.3em;
  padding-left: 1em;
  width: 200px;
  box-sizing: border-box;
  font-size: 1.2em;
  outline: none;
  color: #d0d0d0;
  border-radius: 4px;
`;
const InputControl = styled.div`
  margin-top: 1em;
  margin-bottom: 1em;
  display: flex;
`;
const FishList = styled.div`
  margin-top: 1em;
  margin-bottom: 1em;
`;
const Button = styled.div`
  min-width: 60px;
  height: 44px;
  padding: 0.5em 0.85em;
  box-sizing: border-box;
  border-radius: 12px;
  text-align: center;
  margin-left: 0.5em;
  cursor: pointer;
  white-space: nowrap;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.colors.text};
  background-color: ${({ theme }) => theme.colors.peg_background};
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.outline};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: filter 0.15s ease, transform 0.08s ease;
  &:active {
    transform: translateY(1px);
  }
`;

const Icon = styled.div`
  color: #db0741;
  margin-right: 0.5em;
  font-size: 1.2em;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const WeighIns = styled.div`
  display: flex;
`;
const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-bottom: solid 1px ${({ theme }) => theme.colors.outline};
  padding: 0 0.5em 0.85em;
  box-sizing: border-box;
`;
// Back (left) and the DARK/LIGHT chips (right) always share this row; the peg
// name drops onto its own line below (CenterColumn), so the controls never wrap.
const TopRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 0.5em;
`;
const Name = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 1.5em;
`;

const WeighIn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: ${(props) => (props.hasData ? "2em" : "4em")};
  font-weight: 600;
  background-color: ${({ theme }) => theme.colors.peg_background};
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.outline};
  border-radius: 18px;
  width: 45%;
  height: 150px;
  box-sizing: border-box;
  cursor: pointer;
  /* px, not em: this box's font-size changes with hasData, and an em margin
     would resize with it and reflow the grid to one tile per row. */
  margin: 5px;
  opacity: ${(props) => (props.hasData ? ".5" : "1")};
  transition: transform 0.08s ease, filter 0.15s ease;
  &:active {
    transform: scale(0.97);
  }
`;
const WeighInTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.5em;
  font-weight: 100;
`;

const WeighInContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
`;
// The controls sit on the top line; the peg name drops onto its own full-width
// line below them, so a long name can never collide with the buttons on a phone.
const Column = styled.div`
  flex: 0 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
`;
const CenterColumn = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 0.4em;
`;
const WeighInNumber = styled.div`
  font-size: 1.2em;
  padding-left: 0.7em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Buttons = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: end;
`;
export default function MobileNet({
  onBack,
  data,
  addFish,
  addFishCount,
  HandleThemeChange,
  mode = "weight",
  backLabel = "Peg Select",
}) {
  const [weighInNumber, setWeighInNumber] = useState();
  let weighInFish = data.fish.find((fish) => fish.weighIn === weighInNumber);
  
  let totalFishWeigh = data.totalFish?.find((fish) => fish.weighIn === weighInNumber)?.total ?? 0;
  let totalFish = data.totalFish?.length ?? 0;
  return (
    <Main>
      <Header>
        <TopRow>
          <Column>
            {!weighInNumber && (
              <Button onClick={onBack}>
                <MdChevronLeft />
                {backLabel}
              </Button>
            )}
            {weighInNumber && mode === "count" && (
              <Button onClick={() => setWeighInNumber(null)}>
                <MdChevronLeft />
                Back
              </Button>
            )}
            {mode !== "count" &&
            <WeighInNumber>
              {weighInNumber ? "WeighIn #" + weighInNumber : ""}
            </WeighInNumber>
            }
             {mode === "count" &&
            <WeighInNumber>
              {weighInNumber ? "Session #" + weighInNumber : ""}
            </WeighInNumber>
            }
          </Column>
          <Column>
            {HandleThemeChange && (
              <Buttons>
                <Button
                  onClick={() => {
                    HandleThemeChange("dark");
                  }}
                >
                  DARK
                </Button>
                <Button
                  onClick={() => {
                    HandleThemeChange("light");
                  }}
                >
                  LIGHT
                </Button>
              </Buttons>
            )}
          </Column>
        </TopRow>
        <CenterColumn>
          <Name>
            Peg {data.number} - {data.name.first}{" "}
            {data.name.last.toUpperCase()}
          </Name>
        </CenterColumn>
      </Header>
      {mode === 'weight' &&
      <>
      {!weighInNumber && (
        <WeighInContainer>
          {new Array(10).fill(1).map((item, index) => {
            let caught = data.fish.find((fish) => fish.weighIn === index + 1);
            return (
              <WeighIn
                hasData={caught}
                onClick={() => {
                  setWeighInNumber(index + 1);
                }}
              >
                <WeighInTitle>Weigh-In</WeighInTitle>
                <div>#{index + 1}</div>
                <div>{caught && caught.weight + "kg"}</div>
              </WeighIn>
            );
          })}
        </WeighInContainer>
      )}
      {weighInNumber && (
        <DataEntry
          initialWeight={weighInFish ? weighInFish.weight : ""}
          onCancel={() => {
            setWeighInNumber(null);
          }}
          onSave={(weight) => {
            addFish(data.number, weight, weighInNumber);
            setWeighInNumber(null);
          }}
        />
      )}
      </>
}

      {mode === 'count' &&
      <>
      {!weighInNumber && (
        <WeighInContainer>
          {new Array(10).fill(1).map((item, index) => {
            let caught = data.totalFish?.find((fish) => fish.weighIn === index + 1)?.total;
            return (
              <WeighIn
                hasData={caught > -1}
                onClick={() => {
                 setWeighInNumber(index + 1);
                }}
              >
                <WeighInTitle>Session</WeighInTitle>
                <div>#{index + 1}</div>
                <div>{caught}</div>
              </WeighIn>
            );
          })}
        </WeighInContainer>
      )}
      {weighInNumber && (
        <CountDataEntry
          initialTotalWeighIn={totalFishWeigh}
          onSave={(total) => {
            addFishCount(data.number, total, weighInNumber);
          }}
          onDone={() => {
            setWeighInNumber(null);
          }}
        />
      )}
      </>
}

      {/* <InputControl>
        <WeightInput
          value={weight}
          placeholder="Fish Weight"
          type="number"
          // placeholder="1.0"
          step="0.001"
          onChange={(e) => setWeight(parseFloat(e.currentTarget.value))}
          // min="0"
          // max="10"
        ></WeightInput>
        <Button
          onClick={() => {
            if (parseFloat(weight)) {
              addFish(selectedPeg.number, weight);
            }
          }}
        >
          Add Fish
        </Button>
      </InputControl> */}
    </Main>
  );
}
